module.exports = __webpack_public_path__ + "img/37800.4c4d8ad8.jpg";